import React, { useEffect, useRef, useState } from "react";

/** Minimal trailing cursor — disabled on touch devices. */
export const CustomCursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    setEnabled(true);
    let rx = 0, ry = 0, tx = 0, ty = 0;
    const move = (e) => {
      tx = e.clientX; ty = e.clientY;
      if (dot.current) dot.current.style.transform = `translate(${tx}px, ${ty}px) translate(-50%, -50%)`;
    };
    let raf;
    const loop = () => {
      rx += (tx - rx) * 0.15;
      ry += (ty - ry) * 0.15;
      if (ring.current) ring.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", move);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div ref={dot} className="yk-cursor" aria-hidden />
      <div ref={ring} className="yk-cursor-ring" aria-hidden />
    </>
  );
};

export default CustomCursor;
